import { PHeadline, PButton, PFlexItem, PFlex, PTextFieldWrapper } from '@porsche-design-system/components-react'
import React from 'react'

import * as AppApi from '../../shared/utils/api/Apps'

import Content from '../../shared/components/Content/Content'
import ContentHeader from '../../shared/components/Content/Header/ContentHeader'
import ContentMain from '../../shared/components/Content/Main/ContentMain'
import ContentToast from '../../shared/components/Content/Toast/ContentToast'
import { ApplicationContext } from '../../shared/utils/Context/ApplicationContext'
import ContentApplicationsList from './ApplicationsList/ContentApplicationsList'

import { PortalContext } from '../../shared/utils/PortalContext'

import styles from './applications.module.css'

export default function ApplicationContent() {
  const { setOpenDrawer, setDrawerContent, setDrawerData, error, setError, setToastContent, setToast } =
    React.useContext(PortalContext)
  const { setSearchValue, searchValue, applications, setApplications, setLoadingApps } =
    React.useContext(ApplicationContext)

  const openDrawer = () => {
    setDrawerData({})
    setOpenDrawer(true)
    setDrawerContent('NewApp')
  }

  React.useEffect(() => {
    if (applications.length >= 1 && error === false) {
      if (Object.keys(applications[0]).length === 0) {
        AppApi.getAll()
          .then((response) => {
            return response.json()
          })
          .then((data) => {
            setApplications(data)
            setLoadingApps(false)
          })
          .catch((err) => {
            setError(true)
            setToastContent(err.message)
            setToast(true)
          })
      }
    }
  })

  const searchInApps = (event: any) => {
    if (event.target.value.length >= 3) {
      if (searchValue !== event.target.value) {
        return setSearchValue(event.target.value)
      }
    }
    if (searchValue !== '') {
      setSearchValue('')
    }
  }

  return (
    <Content>
      <ContentHeader>
        <PFlex className={styles.head} justifyContent='space-between'>
          <PFlexItem>
            <PButton variant='tertiary' icon='plus' onClick={openDrawer}>
              Applikation hinzufügen
            </PButton>
          </PFlexItem>
          <PFlexItem>
            <PTextFieldWrapper>
              <input type='search' name='suche' onChange={searchInApps} placeholder='Suche in Applikationen' />
            </PTextFieldWrapper>
          </PFlexItem>
        </PFlex>
      </ContentHeader>
      <ContentMain>
        <PHeadline variant='headline-5'>Applikationen</PHeadline>
        <ContentApplicationsList />
      </ContentMain>
      <ContentToast />
    </Content>
  )
}
